(() => {
  const V = window.veloria || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  // ---------- argent
  function money(cents) {
    const fmt = String(V.moneyFormat || "{{amount_with_comma_separator}}€").replace(/<[^>]*>/g, "");
    const n = (cents / 100);
    const two = n.toFixed(2);
    const thou = (s, sep) => s.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (m, k) => {
      switch (k) {
        case "amount_no_decimals": return thou(String(Math.round(n)), ",");
        case "amount_with_comma_separator": { const [i, d] = two.split("."); return thou(i, ".") + "," + d; }
        case "amount_no_decimals_with_comma_separator": return thou(String(Math.round(n)), ".");
        case "amount_with_space_separator": { const [i, d] = two.split("."); return thou(i, " ") + "," + d; }
        default: { const [i, d] = two.split("."); return thou(i, ",") + "." + d; }
      }
    });
  }
  const esc = s => String(s).replace(/[&<>"']/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));

  // ---------- toast
  let tt;
  function toast(msg) {
    const el = $("[data-toast]"); if (!el) return;
    el.textContent = msg; el.hidden = false;
    clearTimeout(tt); tt = setTimeout(() => (el.hidden = true), 2600);
  }

  // ---------- bandeau
  const msgs = $$(".announce-msg");
  if (msgs.length > 1 && !matchMedia("(prefers-reduced-motion: reduce)").matches) {
    let i = 0;
    setInterval(() => { msgs[i].classList.remove("is-active"); i = (i + 1) % msgs.length; msgs[i].classList.add("is-active"); }, 4500);
  }

  // ---------- menu mobile
  const nav = $("[data-nav]"), mb = $("[data-menu-toggle]");
  if (nav && mb) mb.addEventListener("click", () => { const o = nav.classList.toggle("open"); mb.setAttribute("aria-expanded", o); });

  // ---------- tri collection
  const sort = $("[data-sort]");
  if (sort) sort.addEventListener("change", () => { const u = new URL(location.href); u.searchParams.set("sort_by", sort.value); u.searchParams.delete("page"); location.href = u.toString(); });

  // ---------- galerie produit
  const mainImg = $(".g-main img");
  $$("[data-thumb]").forEach(b => b.addEventListener("click", () => {
    if (!mainImg) return;
    mainImg.removeAttribute("srcset"); mainImg.src = b.dataset.thumb;
    $$("[data-thumb]").forEach(x => x.classList.toggle("is-active", x === b));
  }));

  // ---------- variantes
  $$("[data-product]").forEach(root => {
    const priceEl = $("[data-price]", root), x3 = $("[data-x3]", root), btn = $("[data-add-btn]", root);
    $$('input[type=radio][name=id]', root).forEach(r => r.addEventListener("change", () => {
      if (priceEl) priceEl.innerHTML = r.dataset.compare ? `<s>${r.dataset.compare}</s> <b>${r.dataset.price}</b>` : r.dataset.price;
      if (x3) x3.textContent = `ou 3 x ${r.dataset.third} sans frais`;
      const ok = r.dataset.available === "true";
      if (btn) { btn.disabled = !ok; btn.textContent = ok ? "Ajouter au panier" : "Épuisé"; }
      const u = new URL(location.href); u.searchParams.set("variant", r.value); history.replaceState(null, "", u);
    }));
    $$("[data-qty-step]", root).forEach(b => b.addEventListener("click", () => {
      const inp = b.parentElement.querySelector("input");
      inp.value = Math.max(1, (parseInt(inp.value, 10) || 1) + parseInt(b.dataset.qtyStep, 10));
    }));
  });

  // ---------- panier
  const drawer = $("[data-cart-drawer]"), scrim = $("[data-cart-scrim]");
  const onCartPage = location.pathname.replace(/\/$/, "").endsWith("/cart");
  function openCart() { if (!drawer) return; drawer.classList.add("open"); drawer.setAttribute("aria-hidden", "false"); scrim.hidden = false; document.body.classList.add("lock"); $("[data-cart-close]", drawer)?.focus(); }
  function closeCart() { if (!drawer) return; drawer.classList.remove("open"); drawer.setAttribute("aria-hidden", "true"); scrim.hidden = true; document.body.classList.remove("lock"); }

  let lastCount = 0;
  async function getCart() {
    const r = await fetch(V.routes.cart + ".js?t=" + Date.now(), { credentials: "same-origin", cache: "no-store", headers: { Accept: "application/json" } });
    if (!r.ok) throw new Error("cart " + r.status);
    return r.json();
  }
  async function refresh() { const c = await getCart(); render(c); return c; }

  function render(cart) {
    lastCount = cart.item_count;
    $$("[data-cart-count]").forEach(el => { el.textContent = cart.item_count; el.classList.remove("pop"); void el.offsetWidth; el.classList.add("pop"); });
    const list = $("[data-cart-items]");
    if (list) {
      list.innerHTML = cart.items.length ? cart.items.map((it, i) => {
        const name = esc(it.product_title.split(" – ")[0]);
        const vt = it.variant_title && it.variant_title !== "Default Title" ? `<span class="muted">${esc(it.variant_title)}</span>` : "";
        const img = it.image ? `<img src="${esc(it.image)}${it.image.includes("?") ? "&" : "?"}width=200" alt="" loading="lazy">` : "";
        return `<div class="item">
          <a class="mini" href="${esc(it.url)}">${img}</a>
          <div class="meta"><a class="pname" href="${esc(it.url)}">${name}</a>${vt}
            <div class="qtyline"><button type="button" data-line="${i + 1}" data-qty="${it.quantity - 1}" aria-label="Retirer un">−</button><span>${it.quantity}</span><button type="button" data-line="${i + 1}" data-qty="${it.quantity + 1}" aria-label="Ajouter un">+</button></div>
            <button type="button" class="rm" data-line="${i + 1}" data-qty="0">Supprimer</button></div>
          <span class="price">${money(it.final_line_price)}</span></div>`;
      }).join("") : `<div class="empty"><p>Ton panier est vide.</p><button type="button" class="btn" data-cart-close>Continuer mes achats</button></div>`;
    }
    const sub = $("[data-cart-subtotal]"); if (sub) sub.textContent = money(cart.total_price);
    const x3 = $("[data-cart-x3]"); if (x3) x3.textContent = cart.total_price ? `ou 3 x ${money(Math.round(cart.total_price / 3))} sans frais` : "";
    const co = $("[data-checkout]"); if (co) co.disabled = !cart.item_count;
    const t = V.freeShipping || 0, st = $("[data-ship-text]"), sb = $("[data-ship-bar]");
    if (t > 0 && st && sb) {
      const left = t - cart.total_price;
      st.innerHTML = left > 0 ? `Plus que <b>${money(left)}</b> pour la livraison offerte` : "Livraison offerte débloquée ✓";
      sb.style.width = Math.min(100, (cart.total_price / t) * 100) + "%";
    }
  }

  async function change(line, quantity) {
    const r = await fetch(V.routes.change + ".js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line, quantity }) });
    if (r.ok) render(await r.json()); else toast("Quantité indisponible");
  }

  document.addEventListener("click", e => {
    const op = e.target.closest("[data-cart-open]");
    if (op && drawer && !onCartPage) { e.preventDefault(); openCart(); refresh(); return; }
    if (e.target.closest("[data-cart-close]") || e.target === scrim) { closeCart(); return; }
    const ln = e.target.closest("[data-line]");
    if (ln) change(+ln.dataset.line, +ln.dataset.qty);
  });
  document.addEventListener("keydown", e => { if (e.key === "Escape") closeCart(); });

  // Ajout au panier : AJAX, avec repli sur l'envoi classique du formulaire
  // (redirection vers /cart) dès que quelque chose ne se passe pas comme prévu.
  function nativeSubmit(f) { f.removeAttribute("data-ajax-add"); HTMLFormElement.prototype.submit.call(f); }
  document.addEventListener("submit", async e => {
    const f = e.target.closest("form[data-ajax-add]"); if (!f) return;
    if (!window.fetch || !window.FormData) return; // envoi classique
    e.preventDefault();
    const b = f.querySelector("[type=submit]"); const label = b ? b.textContent : "";
    const err = f.querySelector("[data-add-error]"); if (err) err.hidden = true;
    if (b) { b.disabled = true; b.textContent = "Ajout…"; }
    const before = lastCount;
    let ok = false;
    try {
      const r = await fetch(V.routes.add + ".js", { method: "POST", credentials: "same-origin", headers: { Accept: "application/json", "X-Requested-With": "XMLHttpRequest" }, body: new FormData(f) });
      let j = {};
      try { j = await r.json(); } catch (_) {}
      if (r.status === 422) {
        const msg = j.description || j.message || "Ce produit n'est plus disponible dans cette quantité.";
        if (err) { err.textContent = msg; err.hidden = false; } toast(msg);
        return;
      }
      if (!r.ok) throw new Error("add " + r.status);
      let cart;
      try { cart = await refresh(); } catch (_) { location.href = V.routes.cart; return; } // produit ajouté : on montre la page panier
      if (cart.item_count <= before) throw new Error("panier non mis à jour");
      ok = true;
      if (b) b.textContent = "Ajouté ✓";
      if (onCartPage) location.reload(); else openCart();
    } catch (ex) {
      nativeSubmit(f); // le navigateur ajoute le produit et affiche la page panier
      return;
    } finally {
      if (b) { setTimeout(() => { b.disabled = false; b.textContent = label; }, ok ? 1400 : 0); }
    }
  });

  if (drawer) refresh().catch(() => {});
})();
